import { graphql } from "gql";

const INTERNAL_ADMIN_EDIT_USER_MUTATION = graphql(`
  mutation InternalAdminEditUser(
    $organizationId: ID!
    $id: ID!
    $input: AdminEditUserInput!
  ) {
    internalAdminEditUser(
      organizationId: $organizationId
      id: $id
      input: $input
    ) {
      ...InternalAdminUser
    }
  }
`);

export default INTERNAL_ADMIN_EDIT_USER_MUTATION;
